import { cloneDeep } from 'lodash';
import * as BILL_METHOD from '../../../../constants/BillMethod';
import { isFieldVisible } from '../../../../utils/bill-method-util';
import { MERCHANDISE_TYPES } from '../../../../utils/util-constants';
import * as ValidationFields from '../../../../constants/ValidationFields';
import productLineItemPage from './ProductLineItemPage';

const PRODUCT_LINE_ITEM_FIELDS = {
  circulatingInventory: {
    name: 'circulatingInventory',
    label: 'Circulating Inventory',
    isMutable: (lineItem) => {
      return (
        isFieldVisible(
          'circulatingInventory',
          lineItem.billMethod,
          lineItem.adjustedQuantity.circulatingInventory
        ) &&
        lineItem.billMethod !== BILL_METHOD.FlatRatedRent &&
        lineItem.typeOfMerchandise.toUpperCase() !==
          MERCHANDISE_TYPES.GARMENTS &&
        lineItem.billMethod !== BILL_METHOD.PieceRateOnly
      );
    },
    getUpdatedLineItem: (lineItem, value) => {
      const updatedLineItem = cloneDeep(lineItem);
      if (!PRODUCT_LINE_ITEM_FIELDS.circulatingInventory.isMutable(lineItem)) {
        return updatedLineItem;
      }
      updatedLineItem.adjustedQuantity.circulatingInventory = value;

      if (
        updatedLineItem.billMethod === BILL_METHOD.RentBasedOnMinimum &&
        updatedLineItem.baseQuantity.deliveryQuantity !== null &&
        updatedLineItem.baseQuantity.deliveryQuantity !== 0
      ) {
        const ratio =
          updatedLineItem.baseQuantity.circulatingInventory /
          updatedLineItem.baseQuantity.deliveryQuantity;

        updatedLineItem.adjustedQuantity.deliveryQuantity = Math.ceil(
          value / ratio
        );
      }

      return updatedLineItem;
    },
    getValue: (lineItem) => {
      return lineItem.adjustedQuantity.circulatingInventory;
    }
  },
  deliveryFrequency: {
    name: 'deliveryFrequency',
    label: 'Delivery Frequency',
    isMutable: (lineItem) => {
      return false;
    },
    getUpdatedLineItem: (lineItem, value) => {
      const updatedLineItem = cloneDeep(lineItem);
      if (!PRODUCT_LINE_ITEM_FIELDS.deliveryFrequency.isMutable(lineItem)) {
        return updatedLineItem;
      }
      updatedLineItem.deliveryFrequency = value;
      return updatedLineItem;
    },
    getValue: (lineItem) => {
      return lineItem.deliveryFrequency;
    }
  },
  easyCarePrice: {
    name: 'easyCarePrice',
    field: 'imageCarePrice',
    label: 'EasyCare Price',
    // For Phase 2 it will be editable, but for now it will be non-editable
    isMutable: (lineItem) => {
      //   return isFieldVisible(
      //     'easyCarePrice',
      //     lineItem.billMethod,
      //     lineItem.imageCarePrice,
      //     lineItem.typeOfMerchandise
      //   );
      return false;
    },
    getUpdatedLineItem: (lineItem, value) => {
      const updatedLineItem = cloneDeep(lineItem);
      if (!PRODUCT_LINE_ITEM_FIELDS.easyCarePrice.isMutable(lineItem)) {
        return updatedLineItem;
      }
      updatedLineItem.imageCarePrice = value;
      return updatedLineItem;
    },
    getValue: (lineItem) => {
      return lineItem.imageCarePrice;
    }
  },
  inventoryMaintenance: {
    name: 'inventoryMaintenance',
    label: 'Inventory Maintenence',
    visibilityField: 'inventoryMaintenanceType',
    isMutable: (lineItem) => {
      return false;
    },
    getUpdatedLineItem: (lineItem, value) => {
      const updatedLineItem = cloneDeep(lineItem);
      if (!PRODUCT_LINE_ITEM_FIELDS.inventoryMaintenance.isMutable(lineItem)) {
        return updatedLineItem;
      }
      updatedLineItem.adjustedQuantity.inventoryMaintenance = value;
      return updatedLineItem;
    },
    getValue: (lineItem) => {
      return lineItem.adjustedQuantity.inventoryMaintenance;
    }
  },
  minUsePercentage: {
    name: 'minUsePercentage',
    label: 'Min Inv Pct',
    isMutable: (lineItem) => {
      return false;
    },
    getUpdatedLineItem: (lineItem, value) => {
      const updatedLineItem = cloneDeep(lineItem);
      if (!PRODUCT_LINE_ITEM_FIELDS.minUsePercentage.isMutable(lineItem)) {
        return updatedLineItem;
      }
      updatedLineItem.adjustedQuantity.minUsePercentage = value;
      return updatedLineItem;
    },
    getValue: (lineItem) => {
      return lineItem.adjustedQuantity.minUsePercentage;
    }
  },
  priceItem: {
    name: 'priceItem',
    label: 'Sales Price',
    isMutable: (lineItem) => {
      return (
        isFieldVisible(
          'priceItem',
          lineItem.billMethod,
          lineItem.adjustedPrice.priceItem
        ) && lineItem.originalPrice.priceItem >= 0
      );
    },
    getUpdatedLineItem: (lineItem, value) => {
      const updatedLineItem = cloneDeep(lineItem);
      if (!PRODUCT_LINE_ITEM_FIELDS.priceItem.isMutable(lineItem)) {
        return updatedLineItem;
      }
      updatedLineItem.adjustedPrice.priceItem = value;
      return updatedLineItem;
    },
    getValue: (lineItem) => {
      return lineItem.adjustedPrice.priceItem;
    }
  },
  priceRental: {
    name: 'priceRental',
    label: 'Rental Price',
    isMutable: (lineItem) => {
      return (
        isFieldVisible(
          'priceRental',
          lineItem.billMethod,
          lineItem.adjustedPrice.priceRental
        ) && lineItem.originalPrice.priceRental >= 0
      );
    },
    getUpdatedLineItem: (lineItem, value) => {
      const updatedLineItem = cloneDeep(lineItem);
      if (!PRODUCT_LINE_ITEM_FIELDS.priceRental.isMutable(lineItem)) {
        return updatedLineItem;
      }
      updatedLineItem.adjustedPrice.priceRental = value;
      return updatedLineItem;
    },
    getValue: (lineItem) => {
      return lineItem.adjustedPrice.priceRental;
    }
  },
  priceReplace: {
    name: 'priceReplace',
    label: 'Replace Price',
    isMutable: (lineItem) => {
      return (
        isFieldVisible(
          'replacePrice',
          lineItem.billMethod,
          lineItem.adjustedPrice.priceReplace
        ) && lineItem.originalPrice.priceReplace >= 0
      );
    },
    getUpdatedLineItem: (lineItem, value) => {
      const updatedLineItem = cloneDeep(lineItem);
      if (!PRODUCT_LINE_ITEM_FIELDS.priceReplace.isMutable(lineItem)) {
        return updatedLineItem;
      }
      updatedLineItem.adjustedPrice.priceReplace = value;
      return updatedLineItem;
    },
    getValue: (lineItem) => {
      return lineItem.adjustedPrice.priceReplace;
    }
  },
  priceWash: {
    name: 'priceWash',
    label: 'Wash Price',
    isMutable: (lineItem) => {
      return (
        isFieldVisible(
          'priceWash',
          lineItem.billMethod,
          lineItem.adjustedPrice.priceWash
        ) && lineItem.originalPrice.priceWash >= 0
      );
    },
    getUpdatedLineItem: (lineItem, value) => {
      const updatedLineItem = cloneDeep(lineItem);
      if (!PRODUCT_LINE_ITEM_FIELDS.priceWash.isMutable(lineItem)) {
        return updatedLineItem;
      }
      updatedLineItem.adjustedPrice.priceWash = value;
      return updatedLineItem;
    },
    getValue: (lineItem) => {
      return lineItem.adjustedPrice.priceWash;
    }
  },
  rentalQuantity: {
    name: 'rentalQuantity',
    label: 'Rental Quantity',
    isMutable: (lineItem) => {
      return (
        isFieldVisible(
          'rentalQuantity',
          lineItem.billMethod,
          lineItem.adjustedQuantity.rentalQuantity
        ) &&
        lineItem.billMethod === BILL_METHOD.FlatRatedRent &&
        lineItem.typeOfMerchandise.toUpperCase() !==
          MERCHANDISE_TYPES.GARMENTS &&
        lineItem.baseQuantity.rentalQuantity !== 0
      );
    },
    getUpdatedLineItem: (lineItem, value) => {
      const updatedLineItem = cloneDeep(lineItem);
      if (!PRODUCT_LINE_ITEM_FIELDS.rentalQuantity.isMutable(lineItem)) {
        return updatedLineItem;
      }
      updatedLineItem.adjustedQuantity.rentalQuantity = value;
      const ratio =
        lineItem.baseQuantity.circulatingInventory /
        lineItem.baseQuantity.rentalQuantity;
      updatedLineItem.adjustedQuantity.circulatingInventory = Math.ceil(
        value * ratio
      );

      if (
        lineItem.baseQuantity.deliveryQuantity != null &&
        lineItem.baseQuantity.deliveryQuantity !== 0
      ) {
        const delToCirInvRatio =
          lineItem.baseQuantity.circulatingInventory /
          lineItem.baseQuantity.deliveryQuantity;

        updatedLineItem.adjustedQuantity.deliveryQuantity =
          updatedLineItem.adjustedQuantity.circulatingInventory /
          delToCirInvRatio;
      }
      return updatedLineItem;
    },
    getValue: (lineItem) => {
      return lineItem.adjustedQuantity.rentalQuantity;
    }
  },
  deliveryQuantity: {
    name: 'deliveryQuantity',
    label: 'Del Quantity',
    isMutable: (lineItem) => {
      return (
        isFieldVisible(
          'deliveryQuantity',
          lineItem.billMethod,
          lineItem.adjustedQuantity.deliveryQuantity
        ) &&
        (lineItem.billMethod === BILL_METHOD.PieceRateOnly ||
          lineItem.billMethod === BILL_METHOD.RentBasedOnMinimum) &&
        lineItem.baseQuantity.deliveryQuantity !== null &&
        lineItem.baseQuantity.deliveryQuantity !== 0 &&
        lineItem.typeOfMerchandise.toUpperCase() !== MERCHANDISE_TYPES.GARMENTS
      );
    },
    getUpdatedLineItem: (lineItem, value) => {
      const updatedLineItem = cloneDeep(lineItem);
      if (!PRODUCT_LINE_ITEM_FIELDS.deliveryQuantity.isMutable(lineItem)) {
        return updatedLineItem;
      }
      updatedLineItem.adjustedQuantity.deliveryQuantity = value;

      if (
        updatedLineItem.billMethod === BILL_METHOD.RentBasedOnMinimum &&
        updatedLineItem.baseQuantity.deliveryQuantity !== null &&
        updatedLineItem.baseQuantity.deliveryQuantity !== 0
      ) {
        const ratio =
          updatedLineItem.baseQuantity.circulatingInventory /
          updatedLineItem.baseQuantity.deliveryQuantity;

        updatedLineItem.adjustedQuantity.circulatingInventory = Math.ceil(
          ratio * value
        );
      }

      return updatedLineItem;
    },
    getValue: (lineItem) => {
      return lineItem.adjustedQuantity.deliveryQuantity;
    }
  },
  weeklyUsage: {
    name: 'weeklyUsage',
    label: 'Weekly Usage',
    isMutable: (lineItem) => {
      return (
        isFieldVisible(
          'weeklyUsage',
          lineItem.billMethod,
          lineItem.adjustedQuantity.weeklyUsage
        ) && isQtyValid(lineItem.baseQuantity.weeklyUsage)
      );
    },
    getUpdatedLineItem: (lineItem, value) => {
      const updatedLineItem = cloneDeep(lineItem);
      if (!PRODUCT_LINE_ITEM_FIELDS.weeklyUsage.isMutable(lineItem)) {
        return updatedLineItem;
      }
      updatedLineItem.adjustedQuantity.weeklyUsage = value;

      // BILLING METHOD 6 LOGIC
      // BASED ON WEEKLY USAGE AND CIRC INVENTORY/DELIVERY QUANTITY/RENTAL QUANTITY MULTIPLIERS
      let deliveryPerWeekValue = 0;
      if(
        updatedLineItem.billMethod === "WeeklyUsage"
      ){
        if(!updatedLineItem.adjustedQuantity.deliveryPerWeek){
          deliveryPerWeekValue = 1;
        }
        else {
          deliveryPerWeekValue = updatedLineItem.adjustedQuantity.deliveryPerWeek;
        }
        updatedLineItem.adjustedQuantity.circulatingInventory = Math.ceil(updatedLineItem.adjustedQuantity.weeklyUsage * updatedLineItem.adjustedQuantity.circulationInventoryMultiplier);
        updatedLineItem.adjustedQuantity.deliveryQuantity = Math.ceil(updatedLineItem.adjustedQuantity.weeklyUsage * (updatedLineItem.adjustedQuantity.deliveryQuantityMultiplier/100) * deliveryPerWeekValue);
        updatedLineItem.adjustedQuantity.rentalQuantity = Math.ceil(updatedLineItem.adjustedQuantity.weeklyUsage * updatedLineItem.adjustedQuantity.rentQuantityMultiplier);
        return updatedLineItem;
      }

      if (
        isQtyValid(lineItem.baseQuantity.circulatingInventory) &&
        isQtyValid(lineItem.baseQuantity.weeklyUsage)
      ) {
        const weeklyUsageCircQtyRatio =
          updatedLineItem.baseQuantity.circulatingInventory /
          updatedLineItem.baseQuantity.weeklyUsage;
        updatedLineItem.adjustedQuantity.circulatingInventory =
          value * weeklyUsageCircQtyRatio;
      }
      return updatedLineItem;
    },
    getValue: (lineItem) => {
      return lineItem.adjustedQuantity.weeklyUsage;
    }
  }
};

const isQtyValid = (quantity) => quantity !== null && quantity > 0;

const isFieldMutable = (field, lineItem) => {
  if (!Object.keys(PRODUCT_LINE_ITEM_FIELDS).includes(field)) {
    return false;
  }
  return PRODUCT_LINE_ITEM_FIELDS[field].isMutable(lineItem);
};

const containsMutableField = (mutableFields) => {
  return Object.values(mutableFields).includes(true);
};

const checkFieldValidation = (responses, fieldName, validityLevels = []) => {
  let validationFields = responses
    .filter((res) => validityLevels.includes(res.validityLevel))
    .map(({ validationField }) => validationField.toUpperCase());

  switch (fieldName) {
    case PRODUCT_LINE_ITEM_FIELDS.priceRental.name:
      return validationFields.includes(ValidationFields.RENTAL_PRICE);
    case PRODUCT_LINE_ITEM_FIELDS.priceItem.name:
      return validationFields.includes(ValidationFields.SALES_PRICE);
    case PRODUCT_LINE_ITEM_FIELDS.priceReplace.name:
      return validationFields.includes(ValidationFields.REPLACE_PRICE);
    case PRODUCT_LINE_ITEM_FIELDS.priceWash.name:
      return validationFields.includes(ValidationFields.WASH_PRICE);
    case PRODUCT_LINE_ITEM_FIELDS.minUsePercentage.name:
      return validationFields.includes(ValidationFields.MIN_USE_PERCENTAGE);
    case PRODUCT_LINE_ITEM_FIELDS.rentalQuantity.name:
      return validationFields.includes(ValidationFields.RENTAL_QUANTITY);
    case PRODUCT_LINE_ITEM_FIELDS.deliveryQuantity.name:
      return validationFields.includes(ValidationFields.DELIVERY_QUANTITY);
    case PRODUCT_LINE_ITEM_FIELDS.inventoryMaintenance.name:
      return validationFields.includes(ValidationFields.INVENTORY_MAINTENANCE);
    case PRODUCT_LINE_ITEM_FIELDS.circulatingInventory.name:
      return validationFields.includes(ValidationFields.CIRCULATING_INVENTORY);
    default:
      return false;
  }
};

export {
  PRODUCT_LINE_ITEM_FIELDS,
  isFieldMutable,
  containsMutableField,
  checkFieldValidation
};
